var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M12.8 2.824l5.331 24.128c.214.965 1.17 1.575 2.134 1.362l3.228-.714c.965-.213 1.575-1.17 1.361-2.134L19.544 1.43C19.333.484 18.41-.125 17.458.058L14.21.68c-.991.189-1.63 1.16-1.411 2.144M5.146.094L1.84.001C.832-.03 0 .78 0 1.79V26.5c0 .989.801 1.79 1.79 1.79h3.306c.988 0 1.789-.801 1.789-1.79V1.883c0-.97-.77-1.762-1.739-1.79m-.223 25.189h-2.96c-.226 0-.408-.183-.408-.409 0-.225.182-.408.408-.408h2.96c.226 0 .408.183.408.408 0 .226-.182.409-.408.409",
    transform: "translate(.038 .75)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8DED1",
    d: "M11.995 6.622L8.69 6.528c-1.008-.028-1.84.781-1.84 1.79V26.5c0 .988.8 1.79 1.79 1.79h3.305c.988 0 1.79-.802 1.79-1.79V8.41c0-.968-.771-1.76-1.74-1.788m-.223 19.23h-2.96c-.225 0-.408-.183-.408-.409 0-.225.183-.407.408-.407h2.96c.226 0 .408.182.408.407 0 .226-.182.408-.408.408",
    transform: "translate(.038 .75)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.43cf927890111a9b69753fb51dc38b41.svg";
export { ForwardRef as ReactComponent };